module.exports = __webpack_public_path__ + "images/unboxing_videos/close_button-e1450119e775528bf062295070414603.png";